<template>
  <div
    class="el-badge rt-badge"
    :class="{ 'state-point': statePoint }"
  >
    <slot></slot>
    <transition name="el-zoom-in-center">
      <sup
        v-if="content !== 0 || visible"
        v-show="!hidden && (content || content === 0 || isDot || statePoint)"
        ref="sup"
        class="el-badge__content"
        :class="[
          'el-badge__content--' + type,
          {
            'is-fixed': $slots.default,
            'is-dot': isDot,
            'is-stroke': isStroke
          }
        ]"
        :style="{
          padding: padding,
          backgroundColor: bgColor,
          top: supTop,
          right: supRight
        }"
        v-text="content"
      >
      </sup>
    </transition>
  </div>
</template>

<script>
import config from '../../config';
export default {
  name: 'RtBadge',
  props: {
    value: [String, Number],
    max: [String, Number],
    isDot: Boolean,
    hidden: Boolean,
    /**
     * @public 增加状态点类型
     */
    type: {
      type: String,
      validator (val) {
        return (
          [
            'primary',
            'branch',
            'normal',
            'success',
            'warning',
            'danger',
            'info',
            'secondary',
            'error',
            'processing',
            'default',
            'purple',
            'pink',
            'yellow'
          ].indexOf(val) > -1
        );
      }
    },
    top: String,
    right: String,
    /**
     * @public 自定义 padding
     */
    padding: String,
    /**
     * @public 值为0默认不显示，除非visible为true
     */
    visible: {
      type: Boolean,
      default: false
    },
    /**
     * @public 自定义背景色
     */
    bgColor: String,
    /**
     * @public 支持显示描边 （全局），也支持单独控制
     */
    isStroke: {
      type: Boolean,
      default: function () {
        return config.get('badge.isStroke');
      }
    },
    /**
     * @public 启用状态点类型
     */
    statePoint: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      supTop: '',
      supRight: ''
    };
  },
  computed: {
    content () {
      if (this.isDot || this.statePoint) return;

      let value = this.value;
      let max = this.max;
      if (/^[0-9]*$/.test(value)) {
        value = Number(value);
      }
      if (/^[0-9]*$/.test(max)) {
        max = Number(max);
      }

      if (typeof value === 'number' && typeof max === 'number') {
        return max < value ? `${max}+` : value;
      }

      return value;
    }
  },
  watch: {
    value (val, oldVal) {
      // 如果红点从无到有的情况下，需要重新初始化一下定位
      if (!oldVal && val) {
        this.initPosition();
      }
    }
  },
  mounted () {
    this.initPosition();
  },
  methods: {
    initPosition () {
      this.$nextTick(() => {
        this.handleTop();
        this.handleRight();
      });
    },
    handleTop () {
      if (this.$refs.sup) {
        this.supTop =
          Number(window.getComputedStyle(this.$refs.sup).top.slice(0, -2)) +
          Number(this.top) +
          'px';
      }
    },
    handleRight () {
      if (this.$refs.sup) {
        this.supRight =
          Number(window.getComputedStyle(this.$refs.sup).right.slice(0, -2)) +
          Number(this.right) +
          'px';
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtBadge.vue?6f15e21a